import { dataSearchState } from "Pages/Dashboard/dataSearchV2/state";
import { mapIndustriesToListBuilder } from "Pages/Dashboard/DeepResearch/components/prospectFilterVocab";

// find_people argument names -> List Builder filterComponentData keys. Level
// and employee-count ids are the same vocabulary on both sides; industries go
// through the same alias mapping onboarding uses.
const arr = v => (Array.isArray(v) ? v.filter(Boolean).map(String) : []);

// Locations from the model are free text ("United States", "New York",
// "Bengaluru"). The List Builder has separate country/state/city filters; a
// country list is the only one we can fill safely without a geo lookup, so
// anything that is not a known country goes to city (the search's fuzziest
// field) rather than being dropped.
const COUNTRY_RE =
  /^(united states|usa|us|united kingdom|uk|canada|australia|india|germany|france|netherlands|ireland|singapore|spain|italy|sweden|brazil|mexico|japan|israel|switzerland|belgium|denmark|norway|finland|poland|portugal|new zealand|south africa|uae|united arab emirates|philippines|indonesia|malaysia|argentina|colombia|chile)$/i;
const CANON_COUNTRY = { usa: "United States", us: "United States", uk: "United Kingdom", uae: "United Arab Emirates" };
const splitLocations = values => {
  const country = [];
  const city = [];
  arr(values).forEach(v => {
    const key = v.trim().toLowerCase();
    if (COUNTRY_RE.test(key)) country.push(CANON_COUNTRY[key] || v.trim());
    else city.push(v.trim());
  });
  return { country, city };
};

export const toListBuilderFilters = async args => {
  const a = args || {};
  const person = splitLocations(a.locations);
  const hq = splitLocations(a.company_locations);
  const industry = await mapIndustriesToListBuilder(arr(a.industries));
  return {
    title: arr(a.titles),
    titleExclude: arr(a.exclude_titles),
    level: arr(a.levels),
    department: arr(a.departments),
    industry,
    employeeCount: arr(a.employee_count),
    revenue: arr(a.revenue),
    country: person.country,
    city: person.city,
    companyCountry: hq.country,
    companyKeywords: arr(a.company_keywords),
    technologies: arr(a.technologies),
    excludeTeamOwns: true,
    primaryActiveRoleOnly: true
  };
};

// Human-readable chips for the block, in the order the rail shows them.
export const describeFilters = f => {
  const out = [];
  const add = (label, vals) => vals && vals.length && out.push({ label, value: vals.join(", ") });
  add("Title", f.title);
  add("Level", (f.level || []).map(l => l.replace("_", "-")));
  add("Department", f.department);
  add("Industry", f.industry);
  add("Size", f.employeeCount);
  add("Location", [...(f.country || []), ...(f.city || [])]);
  add("HQ", f.companyCountry);
  add("Keywords", f.companyKeywords);
  add("Tech", f.technologies);
  return out;
};

// Sets the page's own filter state and runs the page's own search, exactly
// as if the user had clicked the rail. Resolves to the mapped filters.
export const applyListBuilderFilters = async args => {
  const filters = await toListBuilderFilters(args);
  dataSearchState.setActiveSearchTab("contacts");
  await dataSearchState.applyFiltersFromCompanyExtensionImport(filters);
  return filters;
};
